(() => {
  "use strict";
  const assets = {
  "A": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-a_png.png?v=1775440450",
  "B": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-b_png.png?v=1775440450",
  "C": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-c_png.png?v=1775440450",
  "D": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-d_png.png?v=1775440450",
  "E": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-e_png.png?v=1775440450",
  "F": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-f_png.png?v=1775440450",
  "G": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-g_png.png?v=1775440450",
  "H": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-h-png.png?v=1775440450",
  "I": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-i_png.png?v=1775440450",
  "J": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-j_png.png?v=1775440450",
  "K": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-k_png.png?v=1775440450",
  "L": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-l_png.png?v=1775440450",
  "M": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-m_png.png?v=1775440450",
  "N": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-n_png.png?v=1775440450",
  "O": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-o_png.png?v=1775440450",
  "P": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-p_png.png?v=1775440450",
  "Q": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-q_png.png?v=1775440450",
  "R": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-r_png.png?v=1775440450",
  "S": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-s_png.png?v=1775440450",
  "T": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-t_png.png?v=1775440450",
  "U": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-u_png.png?v=1775440450",
  "V": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-v-png.png?v=1775440450",
  "W": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-w_png.png?v=1775440450",
  "X": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-x_png.png?v=1775440450",
  "Y": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-y_png.png?v=1775440450",
  "Z": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/letter-z_png.png?v=1775440450",
  "[PAW_PRINT]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-paw-print_png.png?v=1775534514",
  "[HEART]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-heart_png.png?v=1775534534",
  "[SANTA]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-santa-christmas-dog-collar.png?v=1790980663",
  "[GINGERBREAD]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-gingerbread-man-dog-collar.png?v=1790980663",
  "[CANDY_CANE]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-candycane-christmas-dog-collar.png?v=1790980663",
  "[FLAMINGO]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-flamingo_png.png?v=1775534550",
  "[PALM_TREE]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-palm-tree_png.png?v=1775534543",
  "[UNICORN]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-unicorn_png.png?v=1775440450",
  "[RAINBOW]": "https://cdn.shopify.com/s/files/1/0026/2671/5715/files/charm-rainbow_png.png?v=1775440450"
};
  const charmNames = {
    '[PAW_PRINT]': 'Paw Print', '[HEART]': 'Heart', '[SANTA]': 'Santa',
    '[GINGERBREAD]': 'Gingerbread Man', '[CANDY_CANE]': 'Candy Cane',
    '[FLAMINGO]': 'Flamingo', '[PALM_TREE]': 'Palm Tree',
    '[UNICORN]': 'Unicorn', '[RAINBOW]': 'Rainbow'
  };
  let items = Array.isArray(window.mu_cart_items) ? window.mu_cart_items : [];
  let frame = 0;
  let wrapper = null;
  let discovery = null;
  const observer = new MutationObserver(schedule);
  const observerOptions = { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-id', 'data-product-id'] };

  function schedule() {
    if (!frame) frame = requestAnimationFrame(render);
  }

  function tokensFor(value) {
    if (typeof value !== 'string' || !value) return [];
    const tokens = value.match(/\[[A-Z_]+\]|[A-Z]/g) || [];
    return tokens.join('') === value && tokens.every(token => assets[token]) ? tokens : [];
  }

  function renderEngraving(row, item) {
    const existing = row.querySelector('.ppm-monster-engraving');
    const valid = item?.key && String(item.product_id) === '8825820774675' && String(item.product_id) === row.dataset.productId;
    const values = valid ? [['Front', item.properties?.['Front Engraving']], ['Back', item.properties?.['Back Engraving']]].filter(([, value]) => typeof value === 'string' && value.trim()) : [];
    const variant = row.querySelector('.mu-item-variants');
    const anchor = variant || row.querySelector('.mu-item-title')?.parentElement;
    if (!values.length || !anchor) {
      existing?.remove();
      return;
    }
    const signature = JSON.stringify(values);
    if (existing?.dataset.lineKey === item.key && existing.dataset.values === signature) {
      if (anchor.nextElementSibling !== existing) anchor.after(existing);
      return;
    }
    const block = document.createElement('div');
    block.className = 'ppm-monster-engraving';
    block.dataset.lineKey = item.key;
    block.dataset.values = signature;
    for (const [label, value] of values) {
      const line = document.createElement('div');
      line.textContent = label + ': ' + value;
      block.append(line);
    }
    existing?.remove();
    anchor.after(block);
  }

  function renderGiftMessage(row, item) {
    const existing = row.querySelector('.ppm3-cart-gift-message');
    const message = item?.properties?.['Gift Message'];
    const valid = item?.key && String(item.product_id) === '15412344881427' &&
      String(item.variant_id || item.id) === '67699250004243' &&
      String(item.product_id) === row.dataset.productId;
    const anchor = row.querySelector('.mu-item-variants') || row.querySelector('.mu-item-title')?.parentElement;
    if (!valid || typeof message !== 'string' || !message.trim() || !anchor) {
      existing?.remove();
      return;
    }
    if (existing?.dataset.lineKey === item.key && existing.textContent === 'Gift Message: ' + message) {
      if (anchor.nextElementSibling !== existing) anchor.after(existing);
      return;
    }
    const block = document.createElement('div');
    block.className = 'ppm3-cart-gift-message';
    block.dataset.lineKey = item.key;
    block.textContent = 'Gift Message: ' + message;
    existing?.remove();
    anchor.after(block);
  }

  function render() {
    frame = 0;
    if (!wrapper) return;
    observer.disconnect();
    try {
      const rows = Array.from(wrapper.querySelectorAll('#mu-items-container .mu-cart-item[data-variant-id]'));
      const ordered = window.mu_dont_reverse_items ? [...items] : [...items].reverse();
      const byVariant = new Map();
      for (const item of ordered) {
        const id = String(item.variant_id || item.id);
        if (!byVariant.has(id)) byVariant.set(id, []);
        byVariant.get(id).push(item);
      }
      const rowCounts = new Map();
      for (const row of rows) {
        const id = row.dataset.variantId;
        rowCounts.set(id, (rowCounts.get(id) || 0) + 1);
      }
      const occurrences = new Map();
      for (const row of rows) {
        const id = row.dataset.variantId;
        const index = occurrences.get(id) || 0;
        occurrences.set(id, index + 1);
        const candidates = byVariant.get(id) || [];
        const item = candidates.length === rowCounts.get(id) ? candidates[index] : null;
        renderEngraving(row, item);
        renderGiftMessage(row, item);
        const tokens = tokensFor(item?.properties?.['_Jewels tokens']);
        const anchor = row.querySelector('.mu-item-variants');
        const existing = row.querySelector('.ppm-monster-jewels');
        if (!item?.key || !tokens.length || !anchor || String(item.product_id) !== row.dataset.productId) {
          if (existing) existing.remove();
          row.removeAttribute('data-ppm-line-key');
          continue;
        }
        row.dataset.ppmLineKey = item.key;
        const signature = tokens.join('');
        if (existing && existing.dataset.lineKey === item.key && existing.dataset.tokens === signature) {
          if (anchor.nextElementSibling !== existing) anchor.after(existing);
          continue;
        }
        const strip = document.createElement('div');
        strip.className = 'ppm-monster-jewels';
        strip.dataset.lineKey = item.key;
        strip.dataset.tokens = signature;
        strip.setAttribute('role', 'group');
        strip.setAttribute('aria-label', tokens.map(token => charmNames[token] || token).join(', '));
        for (const token of tokens) {
          const image = document.createElement('img');
          const url = new URL(assets[token]);
          url.searchParams.set('width', '64');
          image.src = url.href;
          image.alt = charmNames[token] || token;
          image.width = 22;
          image.height = 22;
          image.decoding = 'async';
          strip.append(image);
        }
        if (existing) existing.remove();
        anchor.after(strip);
      }
    } finally {
      observer.observe(wrapper, observerOptions);
    }
  }

  function connect() {
    wrapper = document.getElementById('monster-cart-wrapper');
    if (!wrapper) return false;
    if (discovery) discovery.disconnect();
    observer.observe(wrapper, observerOptions);
    schedule();
    return true;
  }

  document.addEventListener('cart:updated', event => {
    if (!Array.isArray(event.detail?.items)) return;
    items = event.detail.items;
    if (wrapper) schedule();
    else connect();
  });

  if (!connect()) {
    discovery = new MutationObserver(() => connect());
    discovery.observe(document.body, { childList: true });
  }
})();
